import React, { useState, useEffect } from "react";
import { getQuestionaryByName } from "../../../db/questionaries";
import { onlyUnique } from "../../../util/arraysUtil";
import Button from "../../../ui/Button/Button";
import Closed from "../Closed/Closed";
import Open from "./Open/Open";
import Numeric from "./Numeric/Numeric";
import DateQuestionary from "./Date/Date";
import Multi from "../Multi/Multi";
import "./Questionary.css";
import DDown from "../DDown/DDown";

function Questionary({ questionaryId, token, onSaveQuestionary }) {
  const [isFetching, setIsFetching] = useState(true);
  const [fetchedQuestionary, setFetchedQuestionary] = useState({});
  const [userAnswers, setUserAnswers] = useState([]);
  const [invalidKeys, setInvalidKeys] = useState([]);

  useEffect(() => {
    async function getInitialQuestionary() {
      setIsFetching(true);
      const response = await getQuestionaryByName(questionaryId, token);
      setFetchedQuestionary(response.data);
      setIsFetching(false);
    }
    try {
      getInitialQuestionary();
    } catch (error) {
      console.log(error);
    }
  }, [questionaryId, token]);

  if (isFetching) {
    return (
      <div>
        <p>Cargando...</p>
      </div>
    );
  }

  function updateAnswerHandler(ansElement) {
    let clonedAnswers = Object.assign([], userAnswers);
    const answer = clonedAnswers.find((clonedAns) => {
      return clonedAns.key === ansElement.key;
    });
    if (answer) {
      answer.answer = ansElement.answer;
    } else {
      clonedAnswers.push(ansElement);
    }
    setUserAnswers(clonedAnswers);
  }

  function saveQuestionary() {
    const invalids = validateQuestionary();
    setInvalidKeys(invalids);
    if (invalids.length > 0) {
      alert(
        "Cuestionario no válido",
        "Hay algunas respuestas inválidas o preguntas sin contestar."
      );
      return;
    }
    onSaveQuestionary(userAnswers);
  }

  function validateQuestionary() {
    let questions = [];
    let totalQuestions = 0;
    fetchedQuestionary.forEach((section) => {
      if (section.questions) {
        totalQuestions += section.questions.length;
        section.questions.forEach((question) => {
          questions.push(question);
        });
      }
    });
    let invalids = [];
    for (let index = 0; index < totalQuestions; index++) {
      const element = userAnswers.find((ua) => ua.key === index);
      if (element) {
        const { answer, type, minValue, maxValue } = element;
        switch (type) {
          case "open":
            if (!(element.optional || answer.trim().length > 0))
              invalids.push(index);
            break;
          case "numeric":
            const parsedValue = parseInt(answer, 10);
            if (!(parsedValue >= minValue && parsedValue <= maxValue))
              invalids.push(index);
            break;
          case "multi":
            let filtered = answer.filter(
              (a) => a !== undefined && a.trim() !== ""
            );
            filtered = filtered.filter(onlyUnique);
            if (filtered.length === 0) invalids.push(index);
            break;
        }
      } else {
        const question = questions.find((q) => q.key === index);
        if (!question.optional) {
          invalids.push(index);
        }
      }
    }
    return invalids;
  }

  return (
    <div className="questionary">
      {fetchedQuestionary.map((section, i) => {
        return (
          <div className="section" key={i}>
            {section.alertText && (
              <p className="alertText">{section.alertText}</p>
            )}
            <p className="sectionDescription">{section.description}</p>
            {
              section.questions &&
              section.questions.map((question) => {
                if (question.answersType === "closed")
                  return (
                    <Closed
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  );
                if (question.answersType === "open")
                  return (
                    <Open
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  );
                if (question.answersType === "numeric")
                  return (
                    <Numeric
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  );
                if (question.answersType === "date") {
                  return (
                    <DateQuestionary
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  );
                }
                if (question.answersType === "multi") {
                  return (
                    <Multi
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  );
                }
                if (question.answersType === "ddown") {
                  return (
                    <DDown
                      key={question.key}
                      question={question}
                      onUpdateAnswer={updateAnswerHandler}
                      invalidKeys={invalidKeys}
                    />
                  )
                }
                else return <div key={question.key}></div>;
              })}
          </div>
        );
      })}
      <div className="button">
        <Button onPress={saveQuestionary}>Guardar</Button>
      </div>
    </div>
  );
}

export default Questionary;
